<template>
  <div class="small-footer sides-padding">
    <div class="small-footer__container">
      <ul class="small-footer__pay-methods">
        <li v-for="(p, i) in payments" :key="i" class="small-footer__pay-method">
          <span :title="p.title">
            <FileIconComponent :name="p.icon" />
          </span>
        </li>
      </ul>
      <ComradesLogo />
    </div>
  </div>
</template>

<script>
import FileIconComponent from "components/FileIconComponent.vue";
import moment from "moment";
import ComradesLogo from "components/ComradesLogo.vue";

export default {
  name: "SmallFooterComponent",
  data() {
    return {
      year: moment().format("YYYY"),
      payments: [
        {
          title: "Visa",
          icon: "visa",
        },
        {
          title: "Master Card",
          icon: "master-card",
        },
        {
          title: "Мир",
          icon: "mir",
        },
      ],
    };
  },
  components: { ComradesLogo, FileIconComponent },
};
</script>

<style lang="stylus">
.small-footer {
  display: flex;
  align-items center
  justify-content center
  background var(--white)
  border-top 1px solid var(--gray)

  &__container {
    max-width var(--main_width)
    width 100%
    display flex
    align-items center
    justify-content space-between
    flex-wrap wrap
    gap 24px
    padding 14px 0
  }

  &__links {
    display flex
    align-items center
    justify-content space-between
    gap 52px
    +below(960px) {
      display flex
      gap 15px
      flex-direction column
      align-items flex-start
      justify-content flex-start
    }

    *:not(:last-child) {
      position: relative;

      &:after {
        content "|"
        absolute right -26px top bottom
        margin auto 0
        +below(960px) {
          display none
        }
      }
    }

    a {
      text-decoration underline
    }

    a
    span {
      font-weight: 300;
      font-size: 0.875em;
      line-height: 20px;
      color: var(--gray-50);
    }
  }

  &__pay-methods {
    display flex
    align-items center
    gap 10px
  }

  &__pay-method {
    background: var(--white);
    border: 1px solid var(--blue-300);
    box-sizing: border-box;
    border-radius: 4px;
    width 50px
    height 34px
    display inline-flex
    align-items center
    justify-content center

    span {
      display inline-flex
      align-items center
      justify-content center

      .icon,
      .file-icon {
        max-width 24px
        max-height 15px
      }
    }

    &--purple {
      background var(--purple)
    }
  }
}
</style>
